// extracted by mini-css-extract-plugin
export default {"number":"rWyYua9StxYS96SD88R1"};